import { render } from "./ItemColorView.vue?vue&type=template&id=78572054"
import script from "./ItemColorView.vue?vue&type=script&lang=js"
export * from "./ItemColorView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__